import Feed from "../components/Home/Feed";
import Tabbar from "../components/Tabbar"

const tiktoks =[
  {
  username: "mainecoonqueens",
  name: "mainecoonqueens",
  content: "#catsoftiktok #foryoupage #norway #mainecoon",
  soundtrack: "Baywatch (Theme) - The TV Theme Players",
  video: 'mainecoon.mp4',
  profileIMG: "profile1.jpeg",
  likes: 2456456586,
  comments: 2446782,
  shares: 356460,
  verified: true,
},
{
  username: "fathomlesslife",
  name: "CEO of Ocean Animals",
  content: "Six waterspouts simultaneously in the Gulf of Mexico off the coast of Louisiana on Thursday.🎥 Raney Frederick#HelloSpring # waterspout # ocean # sea ",
  soundtrack: "🎵 Stranger Things (Main Theme) - I Love TV Themes",
  video: 'fathomlesslife.mp4',
  profileIMG: "profile2.jpeg",
  likes: 5242345,
  comments: 5685,
  shares: 5610,
  verified: true,
},
{
  username: "mafishguy",
  name: "Fishing Guy",
  content: "Nothing to see here....just #tickling a #fish and making him #laugh ",
  soundtrack: "🎵 original sound - Fishing Guy",
  video: 'mafishguy.mp4',
  profileIMG: "profile3.jpeg",
  likes: 5275645,
  comments: 7585,
  shares: 422610,
  verified: true,
}
]

function Home (props){
  const {isMobile}=props
  return (
    isMobile ? (<div id="Home" className="mobile container-fluid">
      <Tabbar/></div>)
    :
    (<div id="Home" className="col-10 desktop container-fluid">
      <div className="row">
    <Feed tiktoks={tiktoks}/>
  </div>
  </div>));
}

export default Home;